import { createAsyncThunk } from '@reduxjs/toolkit';
import ServiceApi from './../../service/service.api';

export const fetchBuyerCreditRiskEvaluationDetail = createAsyncThunk(
	'sales/buyer-credit-details',
	async (buyer_id: string, thunkAPI) => {
		try {
			const { status, data } = await ServiceApi.getInstance('DS').GET(
				`/buyer_credit_risk_evaluation?customer_id=${buyer_id}`,
			);
			if (status !== 200) throw new Error(data.message ?? 'Something went wrong');
			return data;
		} catch (err: any) {
			return thunkAPI.rejectWithValue(err.message);
		}
	},
);

export const editSalesorder = createAsyncThunk(
	'sales/edit-sales',
	async (salesOrder: any, thunkAPI) => {
		const sales_order_id = salesOrder.orderId;
		delete salesOrder.orderId;
		try {
			const { status, data } = await ServiceApi.getInstance().PATCH(
				`/v1/sales/buyer/order/${sales_order_id}`,
				salesOrder,
			);
			if (status !== 200) throw new Error(data.message ?? 'Something went wrong');
			return data;
		} catch (err: any) {
			return thunkAPI.rejectWithValue(err.message);
		}
	},
);

export const fetchBuyerFinanceDetails = createAsyncThunk(
	'sales/buyer-finance-details',
	async (buyer_id: number, thunkAPI) => {
		try {
			const { status, data } = await ServiceApi.getInstance().GET(
				'/v2/buyer/credit_details',
				{
					params: {
						buyer_id,
					},
				},
			);
			if (status !== 200) throw new Error(data.message ?? 'Something went wrong');
			return data;
		} catch (err: any) {
			return thunkAPI.rejectWithValue(err.message);
		}
	},
);

export const fetchUniqueSalesOeder = createAsyncThunk(
	'sales/unique-order',
	async (id: string, thunkAPI) => {
		try {
			const { status, data } = await ServiceApi.getInstance().GET(
				`/v2/sales_order/so_detail?so_id=${id}`,
			);
			if (status !== 200) throw new Error(data.message ?? 'Something went wrong');
			return data;
		} catch (err: any) {
			return thunkAPI.rejectWithValue(err.message);
		}
	},
);
